<template>
  <li class="kp-list-item">
    <div class="kp-folder-name">
      <input type="text" :value="box.name" @change="boxesSetName(({ event: $event, id: box.id }))">
    </div>
    <div class="kp-folder-testab"></div>
    <div class="kp-folder-updatedate"><locale-date :date="box.updated_at"></locale-date></div>
    <div class="kp-folder-status"></div>

    <button-delete :box="box" :index="index"></button-delete>
    <button-edit :box="box"></button-edit>
    <button-report :box="box"></button-report>
    <button-export :box="box"></button-export>
  </li>
</template>

<script>
import { mapActions } from 'vuex';
import ButtonDelete from './ButtonDelete.vue';
import ButtonEdit from './ButtonEdit.vue';
import ButtonReport from './ButtonReport.vue';
import ButtonExport from './ButtonExport.vue';
import LocaleDate from 'src/components/general/Date.vue';

export default {
  components: {
    'button-delete': ButtonDelete,
    'button-edit': ButtonEdit,
    'button-report': ButtonReport,
    'button-export': ButtonExport,
    LocaleDate,
  },
  props: [
    'box',
    'index',
  ],
  methods: mapActions([
    'boxesSetName',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?de4257fc
 **/